import { registerSteps } from './register.constants';
import { Step, Steps } from './register.types';

export const getStep = (stepKey: string | undefined): Step => {
    if (!stepKey || !(stepKey in registerSteps)) {
        stepKey = 'profile';
    }

    return registerSteps[stepKey];
};


export const getPrimaryRegisterStepKeys = (steps: Steps): string[] =>
    Object.keys(steps).slice(0, 4);

export const getRegisterStepIndex = (
    steps: Steps,
    currentStep: string | undefined,
): number => {
    if (!currentStep || currentStep === 'ticket') return -1;

    return getPrimaryRegisterStepKeys(steps).indexOf(currentStep);
};
